import React from 'react';
import { colorGrid } from 's2s-themes';
import styled from 'styled-components';
import { getIntlText } from '../js/utilities';
import useSettings from "../hooks/settings";
import Checkbox from './checkbox.jsx';

const SettingsContainer = styled.div`
  background-color: ${colorGrid.gray0};
  display: flex;
  flex-direction: column;
  font-family: Open Sans;
  padding: 24px 24px 0 24px;
`;

const SettingsTitle = styled.div`
  color: #001221;
  font-size: 14px;
  font-weight: 600;
  line-height: 12px;
  padding: 10px 0 15px 0;
`;

const SettingsDescription = styled.div`
  color: #4c5863;
  font-size: 14px;
  line-height: 12px;
  padding-bottom: 10px;
`;

// we will need this class if we eventually add language
// const SettingsItemContainer = styled.div`
//   border-bottom: ${"1px solid " + colorGrid.gray3};
//   margin-bottom: 12px;
// `;

const StyledCheckbox = styled(Checkbox)`
  font-size: 14px;
  line-height: 12px;
  padding-bottom: 10px;
`;

const AppearanceSettings = (props) => {
  const [settings, { changeSettings }] = useSettings();
  
  const handleChangeOnTop = (isChecked) => {
    changeSettings({ "alwaysontop": isChecked }, props.intl);
  };

  return (
    <SettingsContainer className="SettingsContainer">
      <SettingsTitle className="SettingsTitleStyles">
        {getIntlText(props.intl, 'SETTINGS-ALWAYS-ON-TOP', "Always on top")}
      </SettingsTitle>
      <SettingsDescription className="SettingsDescriptionStyles" >
        {getIntlText(props.intl, 'SETTINGS-ALWAYS-ON-TOP-DESCRIPTION', "When enabled the application will always display above your other applications.")}
      </SettingsDescription>
      <StyledCheckbox 
        cbChanged={handleChangeOnTop} 
        isChecked={settings && settings.alwaysontop} 
        label={getIntlText(props.intl, 'SETTINGS-ALWAYS-ON-TOP', "Always on top")}
      />
    </SettingsContainer >
  );
};

export default AppearanceSettings;
